import { Marker } from "@react-google-maps/api"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import AppToaster from "utils/AppToaster"
import {
  VEHICLE_ADD_RECOMMENDATION_ROUTE,
  VEHICLE_SELECT_PLOT_COMMODITY,
} from "store/vehicle.redux"
import { getId } from "utils/custom.utils"
import { useTrip } from "../trip/TripContext"
import RecommendationPolyline from "./RecommendationPolyline"

function RecommendationService({ recommendations }) {
  const dispatch = useDispatch()
  const routes = useSelector(state => state.vehicle.recommendations)
  const selectedPlot = useSelector(state => state.vehicle.plotCommodity)

  const { lat, lng } = useTrip()

  return (
    <>
      {recommendations?.map(plotCommodity => {
        return (
          <Marker
            onClick={e => {
              if (!lat || !lng) {
                return AppToaster.show({
                  message:
                    "Unable to locate the vehicle for this trip, please ensure that the vehicle is currently active.",
                  intent: "warning",
                  icon: "warning-sign",
                })
              }
              if (routes?.[plotCommodity?.id]?.routes) {
                dispatch({
                  type: VEHICLE_SELECT_PLOT_COMMODITY,
                  payload: plotCommodity,
                })
                return null
              } else {
                const directionsService =
                  new window.google.maps.DirectionsService()
                directionsService.route(
                  {
                    origin: {
                      lat,
                      lng,
                    },
                    destination: {
                      lat: plotCommodity?.plot?.address?.latitude,
                      lng: plotCommodity?.plot?.address?.longitude,
                    },
                    travelMode: "DRIVING",
                  },
                  (response, status) => {
                    if (status === "OK") {
                      const routes = response?.routes?.[0]?.overview_path
                      dispatch({
                        type: VEHICLE_ADD_RECOMMENDATION_ROUTE,
                        payload: {
                          id: plotCommodity?.id,
                          routes,
                        },
                      })
                    }
                  }
                )
                dispatch({
                  type: VEHICLE_SELECT_PLOT_COMMODITY,
                  payload: plotCommodity,
                })
              }
            }}
            title={plotCommodity?.name}
            position={{
              lat: plotCommodity?.plot?.address?.latitude,
              lng: plotCommodity?.plot?.address?.longitude,
            }}
            key={plotCommodity?.id}
            icon={{
              scaledSize: new window.google.maps.Size(38, 38),
              url: "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png",
            }}
          />
        )
      })}

      {routes &&
        Object.keys(routes).map(r => {
          return (
            <RecommendationPolyline
              key={r}
              isSelected={getId(r) === getId(selectedPlot)}
              path={routes?.[r]?.routes}
            />
          )
        })}
    </>
  )
}

export default RecommendationService
